
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse
} from '@angular/common/http';
import { PROXIES } from '../configs';

@Injectable()
export class HttpService {

  headers: HttpHeaders | { [header: string]: string | string[]; };
  options: any;

  constructor(private http: HttpClient) {
    // this.setHeaders('withToken');
  }

  get(api: any, params: any): Promise<any> {
    params.channel_id = 3;
    // this.setHeaders('withToken');

    try {
      const url = PROXIES.gateway + api + this.parseParams(params);
      console.log(url);
      return new Promise((resolve, reject) => {
        this.http.get(url)
          .subscribe(data => {
            resolve(data);
          }, error => {
            reject(error);
          });
      });
    } catch (err) {
      return new Promise(reject => {
        reject(err);
      });
    }
  }

  get_request(url: any, params: any): Promise<any> {
    params.channel_id = 3;
    console.log(url);
    try {
      url = url + this.parseParams(params);
      return new Promise((resolve, reject) => {
        this.http.get(url)
          .subscribe(data => {
            resolve(data);
          }, error => {
            reject(error);
          });
      });
    } catch (err) {
      return new Promise(reject => {
        reject(err);
      }).catch((err: HttpErrorResponse) => {
        console.log('An error occurred:', err.error);
      });
    }
  }

  get_no_auth(url: any, params: any): Promise<any> {
    params.channel_id = 3;
    console.log(url)
    try {
      document.body.style.cursor = 'wait';
      url = url + this.parseParams(params);
      return new Promise((resolve, reject) => {
        this.http.get(url)
          .subscribe(data => {
            document.body.style.cursor = 'default';
            resolve(data);
          }, error => {
            document.body.style.cursor = 'default';
            reject(error);
          });
      });
    } catch (err) {
      return new Promise(reject => {
        reject(err);
      });
    }
  }

  _get(api: any, params: any): Promise<any> {
    params.channel_id = 3;
    this.setHeaders('withToken');
    try {
      const url = api + this.parseParams(params);
      console.log(url)
      return new Promise((resolve, reject) => {
        this.http.get(url, {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer 084678ad-2f42-4e5a-954f-dbe675f4b1d5'
          }
        })
          .subscribe(data => {
            resolve(data);
          }, error => {
            resolve(error);
          });
      });
    } catch (err) {
      return new Promise(reject => {
        reject(err);
      });
    }
  }


  Hget(host: any, api: any, params: any): Promise<any> {
    params.channel_id = 3;
    this.setHeaders('withToken');
    const me = this;
    const url = host + api + this.parseParams(params);
    // console.debugerror("url", url);
    console.log(url)
    return new Promise((resolve, reject) => {
      this.http.get(url, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer 084678ad-2f42-4e5a-954f-dbe675f4b1d5'
        }
      })
        .subscribe(data => {
          // console.debugerror("data",JSON.stringify(data));
          resolve(data);
        }, error => {
          // console.debugerror("data",JSON.stringify(error));
          reject(error);

        });

    });
  }


  parseParams(data: any): any {
    const arr = Object.keys(data);
    let queryParams = '?';
    for (let i = 0; i < arr.length; i++) {
      queryParams = queryParams + arr[i] + '=' + data[arr[i]] + '&';
    }
    return queryParams;
  }

  parseAuthParams(data: any): any {
    const arr = Object.keys(data);
    let queryParams = '';
    for (let i = 0; i < arr.length; i++) {
      queryParams = queryParams + arr[i] + '=' + data[arr[i]] + '&';
    }
    return encodeURI(queryParams);
  }


  /************************Post Request*******************************/

  PostRequest(host: any, api: any, params: any): Promise<any> {
    const url = host + api;
    console.log(url)
    return new Promise((resolve, reject) => {
      this.http.post(url, params)
        .subscribe(data => {
          resolve(data);
        }, error => {
          reject(error);
        });
    });
  }

  postFileUpload(host: any, api: any, params: any, formData?: any): Promise<any> {
    params.channel_id = 3;
    const url = host + api;
    return new Promise((resolve, reject) => {
      this.http.post(url, formData) //{headers:headers}
        .subscribe(data => {
          resolve(data);
        }, error => {
          reject(error);
        });
    });
  }

  // ajax_post

  Post(url: any, params: any): Promise<any> {
    params.channel_id = 3;
    params.channel = 3;
    console.log(url)
    const me = this;
    return new Promise((resolve, reject) => {
      this.http.post(url, params)
        .subscribe(data => {
          resolve(data);
        }, error => {
          reject(error);
        });
    });
  }

  Post_no_auth(url: any, params: any): Promise<any> {
    //   params.token = CommonUtilities.getSessionStorage('token');
    document.body.style.cursor = 'wait';
    return new Promise((resolve, reject) => {
      this.http.post(url + this.parseParams(params), params) //{headers:headers}
        .subscribe(data => {
          resolve(data);
          document.body.style.cursor = 'default';
        }, error => {
          resolve(error);
          document.body.style.cursor = 'default';
        });
    });
  }


  PUT_NO_AUTH(url: any, params: any): Promise<any> {
    this.setHeaders('');
    // params.token =  CommonUtilities.getSessionStorage('token');
    const me = this;
    document.body.style.cursor = 'wait';
    return new Promise((resolve, reject) => {
      this.http.put(url, params, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer 084678ad-2f42-4e5a-954f-dbe675f4b1d5'
        }
      })
        .subscribe(data => {
          document.body.style.cursor = 'default';
          resolve(data);
        }, error => {
          document.body.style.cursor = 'default';
          // console.debugerror("data",JSON.stringify(error));
          resolve(error);
        });
    });
  }



  ajax_post(url, params) {
    const token = '084678ad-2f42-4e5a-954f-dbe675f4b1d5';
    try {
      const xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          return Promise.resolve(this.responseText);

        }
      };
      xhttp.open('POST', url, true);
      xhttp.send(params);

      // return $.ajax({
      //     url: url,
      //     type: 'POST',
      //     dataType: 'json',
      //     headers: {
      //         'Authorization': 'Bearer ' + token,
      //     },
      //     data: params,
      // });
    } catch (error) {
      console.error('Error', error);
    }
  }

  host_delete(host: any, api: any, param: any): Promise<any> {
    const me = this;
    const url = host + api + '/' + param;
    // console.debugerror("url",url);
    return new Promise((resolve, reject) => {
      this.http.delete(url, me.options)
        .subscribe(data => {
          // console.debugerror("data",JSON.stringify(data));
          resolve(data);
        }, error => {
          // console.debugerror("data",JSON.stringify(error));
          resolve(error);

        });

    });
  }

  setHeaders(type): void {
    this.headers = new HttpHeaders();
    // let token = this.shared.token ? this.shared.token: "084678ad-2f42-4e5a-954f-dbe675f4b1d5";
    const token = '084678ad-2f42-4e5a-954f-dbe675f4b1d5';
    this.headers.append('Content-Type', 'application/json');
    this.headers.append('Accept', 'application/json');
    if (type === 'withToken') {
      this.headers.append('Authorization', 'Bearer ' + token);
    }
    this.options = {
      headers: this.headers
    };
  }
}
